export enum GroupStatus {
  blocked = "1",
  unblocked = "2"
}
